<template lang="html">
  <div class="auth-form-transparent text-left p-3">
    <div class="brand-logo">
      <img src="/img/logo.png" alt="logo"> TradingApp
    </div>
    <h4>{{lang=="ru"?"С возвращением!":"Welcome back!"}}</h4>
    <h6 class="font-weight-light">{{lang=="ru"?"Пожалуйста, введите ваш адрес электронной почты, чтобы сбросить пароль.":"Please, enter your email address to reset the password."}}</h6>
    <h6 class="font-weight-light" style='color: red' :class='errorText ? "" : "invisible"'>{{errorText}}</h6>
    <form class="pt-3">
      <div class="form-group">
        <label>{{email_text}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="mdi mdi-account-outline text-primary"></i>
            </span>
          </div>
          <input type="email" class="form-control form-control-lg border-left-0 input-auth" :placeholder="email_text" v-model='email' v-on:keyup.enter='resetPassword'>
        </div>
      </div>
      <div class="my-3">
        <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" v-on:click='resetPassword' style="color:white">{{lang=="ru"?"Сбросить":"RESET"}}</a>
      </div>
      <div class="text-center mt-4 font-weight-light">
         {{lang=="ru"?"Нет аккаунта? ":"Don't have an account? "}} <router-link to='/signup' class="text-primary" >{{lang=="ru"?"Создать":"Create"}}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',

      errorText: null,
      email_text:"Email",
      lang:'en'
    }
  },
  created(){
      this.lang = this.$cookie.get('lang');
    if(this.lang=="ru"){
      this.email_text="Почта";

    }
  },
  methods: {
    resetPassword () {
      this.errorText = null
      this.axios.get('/send_password_reset_link', {params: {email: this.email}})
        .then((response) => {
          response = response.data
          console.log(response)
          if (response.success) {
            this.$router.push('/mail-sent')
          } else {
            this.errorText = response.message
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordStep1.vue